/**
 * bundle_id от динамики имеет следующий вид:
 * "{ЧТО-ТО}|{ДВЕ ЦИФРЫ ПОСТАВЩИКА АВИА}{ЧТО-ТО ЕЩЕ}|{ДВЕ ЦИФРЫ ПОСТАВЩИКА ОТЕЛЯ}{ЧТО-ТО ЕЩЕ}",
 * ИЛИ
 * "{ЧТО-ТО}|{ДВЕ ЦИФРЫ ПОСТАВЩИКА АВИА}{ЧТО-ТО ЕЩЕ}<{ДВЕ ЦИФРЫ ПОСТАВЩИКА АВИА}{ЧТО-ТО ЕЩЕ}|{ДВЕ ЦИФРЫ ПОСТАВЩИКА ОТЕЛЯ}{ЧТО-ТО ЕЩЕ}"
 * (второй вариант - для пакетных перелетов)
 * этот селектор достает id поставщика отеля
 */
export const parseBundleId = (
  bundleId?: string,
): { avia: string; hotel: string } => {
  try {
    const supplierIds = {
      avia: '',
      hotel: '',
    };

    if (!bundleId) {
      return supplierIds;
    }

    const [, aviaPart, hotelPart] = bundleId.split('|');

    // Если есть < - значит это пакетный перелет
    if (aviaPart.includes('<')) {
      const [firstFlightPart, secondFlightPart] = aviaPart.split('<');
      supplierIds.avia = `${firstFlightPart.slice(
        0,
        2,
      )}|${secondFlightPart.slice(0, 2)}`;
    } else {
      supplierIds.avia = aviaPart.slice(0, 2);
    }

    supplierIds.hotel = hotelPart.slice(0, 2);

    return supplierIds;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Ошибка при парсинге bundleId:', error);
    return { avia: '', hotel: '' };
  }
};
